interface ILTCG_FORMULA {
  time: string;
  holdingPeriodA: string;
  holdingPeriodB: string;
  timePurchase: string;
  sale: number;
  purchase: number;
  expenses: number;
  afterTimeFVM: number;
  tPurchase: number;
}
export const LTCG_FORMULA = ({
  time,
  holdingPeriodA,
  holdingPeriodB,
  timePurchase,
  sale,
  purchase,
  expenses,
  afterTimeFVM,
  tPurchase,
}: ILTCG_FORMULA) => {
  const saleValue = Number(sale);
  const purchaseValue = Number(purchase);
  const transferExpenses = Number(expenses);
  const fairMarketValue = Number(afterTimeFVM);
  const purchaseValueAfterJan2018 = Number(tPurchase);

  if (
    saleValue < 0 ||
    saleValue > 1e13 ||
    purchaseValue < 0 ||
    purchaseValue > 1e12 ||
    fairMarketValue < 0 ||
    fairMarketValue > 1e12 ||
    transferExpenses < 0 ||
    transferExpenses > 1e11 ||
    purchaseValueAfterJan2018 < 0 ||
    purchaseValueAfterJan2018 > 1e12
  ) {
    return {
      shortTerm: 0,
      taxableSTCG: 0,
      shortTermTax: 0,
      longTerm: 0,
      exemption: 0,
      taxableLTCG: 0,
      longTermTax: 0,
      gainTax: '',
      message: '',
    };
  }

  const netSaleValue = saleValue - transferExpenses;
  const isShortTerm = holdingPeriodA === 'Less' || holdingPeriodB === 'Less';
  const isLongTerm = holdingPeriodA === 'More' || holdingPeriodB === 'More';

  let shortTerm = 0;
  let taxableSTCG = 0;
  let shortTermTax = 0;
  let longTerm = 0;
  let exemption = 0;
  let taxableLTCG = 0;
  let longTermTax = 0;
  let message = '';

  if (isShortTerm) {
    const cost = time === 'Before' ? purchaseValue : purchaseValueAfterJan2018;
    shortTerm = Math.max(0, netSaleValue - cost);
    taxableSTCG = shortTerm;
    shortTermTax = Math.round(taxableSTCG * 0.2);
    message = `Short Term Capital Gain of ₹${shortTerm.toLocaleString()} is chargeable to tax @ 20% i.e ₹${shortTermTax.toLocaleString()}`;
  }
  if (isLongTerm) {
    if (holdingPeriodA === 'More' || holdingPeriodB === 'More') {
      if (timePurchase === 'Bef') {
        const effectiveCost = Math.max(
          purchaseValue,
          Math.min(fairMarketValue, netSaleValue)
        );
        longTerm = Math.max(0, netSaleValue - effectiveCost);
      } else if (timePurchase === 'Aft') {
        longTerm = Math.max(0, netSaleValue - purchaseValueAfterJan2018);
      }
      exemption = Math.min(125000, longTerm);
      taxableLTCG = Math.max(0, longTerm - exemption);
      longTermTax = Math.round(taxableLTCG * 0.125);
      message = `Long Term Capital Gain of ₹${longTerm.toLocaleString()} is chargeable to tax @ 12.5% i.e ₹${longTermTax.toLocaleString()}`;
    }
  }
  return {
    shortTerm,
    taxableSTCG,
    shortTermTax,
    longTerm,
    exemption,
    taxableLTCG,
    longTermTax,
    gainTax: message,
    message,
  };
};
